import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

const request = async (userUid, path = '', method, accomplishment) => {
  const response = await fetch(
    `${appConfig.baseApiUrl}/api/v1/users/${userUid}/accomplishments${path}`,
    {
      method,
      headers: {
        ...(await getAuthHeaders()),
        'Content-Type': 'application/json',
      },
      body: accomplishment
        ? JSON.stringify({ accomplishment })
        : undefined,
    },
  );

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.errors?.join(', ') || 'Unable to save accomplishment');
  }

  return response.status === 204 ? null : response.json();
};

export const createAccomplishment = (userUid, accomplishment) =>
  request(userUid, '', 'POST', accomplishment);

export const updateAccomplishment = (userUid, accomplishmentId, accomplishment) =>
  request(userUid, `/${accomplishmentId}`, 'PATCH', accomplishment);

export const deleteAccomplishment = (userUid, accomplishmentId) =>
  request(userUid, `/${accomplishmentId}`, 'DELETE');
